import { Box, BoxProps } from "@chakra-ui/react";
import Image from "next/image";
import { ImageFragment } from "../article-card";

interface PostFeaturedImageProps extends BoxProps {
  image?: ImageFragment & { alt?: string };
}

export const PostFeaturedImage = ({
  image,
  ...rest
}: PostFeaturedImageProps) => {
  return (
    <Box {...rest} position="relative">
      {image && (
        <Image
          {...image}
          src={image.url}
          alt={image.alt ?? image.handle}
          style={{ width: "100%", height: "auto" }}
        />
      )}
    </Box>
  );
};
